(ns dashboard.views.browser-extension.search.config)

(def view-id :route.view/extension-search)
